import BatterTableDataView from "@/components/BatterTableDataView.vue";
import api from "@/api";
import { ElMessage } from "element-plus";
export default {
  name: "DeletedSitePageListView",
  components: {
    BatterTableDataView
  },
  props: {
    site: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      initQuery: null,
      batchSelected: []
    };
  },
  methods: {
    revertDelete(id) {
      api.revertDeletePage(id).then(() => {
        ElMessage.success('操作成功');
        this.$refs.pageList.fetchData();
      });
    },
    gotoEdit(d) {
      window.open('/html/edit/' + d.htmlId, '_blank');
    },
    previewHtml(d) {
      window.open(`/html/preview/${d.htmlId}?footer=${d.footId ? d.footId : ''}&page=${d.id}`, '_blank');
    },
    init() {
      this.initQuery = {
        siteId: this.site.value,
        refId: this.site.value,
        deleted: true
      };
    }
  },
  mounted() {
    this.init();
  }
};